export default {
  RECURRENCE_RULE_SECTION: `Recurrence`,
  frequency: {
    DAILY: `Every day`,
    WEEKLY: `Every week`,
    NONE: `None`
  },
  ends: {
    UNTIL: `On a certain date`,
    COUNT: `After a certain number of shifts`
  },
  form: {
    FREQUENCY: {
      LABEL: `Frequency`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    INTERVAL: {
      LABEL: `Interval`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    ENDS: {
      LABEL: `Ends`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    COUNT: {
      LABEL: `Number of occurences`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``,
      NUMBER_OCCURENCES: 'times'
    },
    UNTIL: {
      LABEL: `End date`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    DAILY: `days`,
    WEEKLY: `weeks`,
    MONDAY: { LABEL: `Mon` },
    TUESDAY: { LABEL: `Tue` },
    WEDNESDAY: { LABEL: `Wed` },
    THURSDAY: { LABEL: `Thu` },
    FRIDAY: { LABEL: `Fri` },
    SATURDAY: { LABEL: `Sat` },
    SUNDAY: { LABEL: `Sun` }
  },
  toText: {
    EVERY: `Every`,
    DAY: `day`,
    DAYS: `days`,
    WEEK: `week`,
    WEEKS: `weeks`,
    WEEKDAY: `weekday`,
    UNTIL: `until`,
    ON: `on`,
    FOR: `for`,
    TIME: `time`,
    TIMES: `times`
  }
}
